import {
  GUESTS
} from './constants'

export const clearLocalStorage = () => {
  window.localStorage.removeItem('zb-search-2021')
}

export const saveToLocalStorage = ({ formData, searchType }) => {
  try {
    const data = {
      formData: {
        entry: formData.entry,
        dates: formData.dates.map(d => {
          if (d === null) {
            return null
          }

          return typeof d.format === 'function' ? d.format('YYYY-MM-DD') : d
        }),
        guests: formData.guests
      },
      searchType
    }

    window.localStorage.setItem('zb-search-2021', JSON.stringify(data))
  }
  catch (e) {}
}

export const fetchFromLocalStorage = () => {
  try {
    const data = JSON.parse(window.localStorage.getItem('zb-search-2021'))
    let entry = data.formData.entry
    if (entry === null || !('title' in entry)) {
      entry = null
    }

    let dates = data.formData.dates
    if (!Array.isArray(dates)) {
      const isValid = dates.every(d => {
        if (d === null) {
          return true
        }

        return moment(d, 'YYYY-MM-DD').isValid()
      })

      if (!isValid) {
        dates = [null, null]
      }
    }
    dates = dates.map(d => {
      if (d === null) {
        return null
      }

      return moment(d, 'YYYY-MM-DD')
    })

    let guests = data.formData.guests
    if (GUESTS.find(g => g.value === guests) === null) {
      guests = '0'
    }

    let mdsmDefaultSearchType = window.zubluSearchType || 'resort'
    let searchType = ['resort', 'liveaboard', 'ecoventure', 'yacht'].includes(data.searchType)
      ? data.searchType
      : mdsmDefaultSearchType

    return {
      formData: {
        entry,
        dates,
        guests
      },
      searchType
    }
  }
  catch (e) {
    clearLocalStorage()

    return {
      formData: {
        entry: null,
        dates: [null, null],
        guests: '0'
      },
      searchType: window.zubluSearchType || 'resort'
    }
  }
}

export const fetchFromURL = () => {
  const cookieValue = fetchFromLocalStorage()
  const urlParams = new URLSearchParams(window.location.search)

  if (window.zubluDestination && typeof window.zubluDestination.name !== 'undefined') {
    cookieValue.formData.entry = { title: window.zubluDestination.name }
  }

  if (urlParams.has('from')) {
    const mmFrom = moment(urlParams.get('from'), 'YYYY-MM-DD')

    if (mmFrom.isValid) {
      cookieValue.formData.dates[0] = moment(urlParams.get('from'), 'YYYY-MM-DD')
    }
  }
  if (urlParams.has('to')) {
    const mmTo = moment(urlParams.get('to'), 'YYYY-MM-DD')

    if (mmTo.isValid) {
      cookieValue.formData.dates[1] = moment(urlParams.get('to'), 'YYYY-MM-DD')
    }
  }
  if (urlParams.has('guests') && urlParams.get('guests') !== '0') {
    cookieValue.formData.guests = urlParams.get('guests')
  }

  return cookieValue
}
